export default class Video {

	static getHolderSelectors = () => ['.video-modal-btn'];

	constructor(videoModalButton) {
		const modal = document.querySelector(videoModalButton.dataset.bsTarget);
		const video = new Vimeo.Player(modal.querySelector('iframe'));

		modal.addEventListener('hidden.bs.modal', () => {
			video.pause();
		});
	}

}
